import React from 'react';
import type { FooterMoreProps } from './types';
import { bridge, isNil, isNotNil, useNavigator } from '../../../../utils';
import type { IScreensLogging } from '../../../../api/types';
import { Flex, PrimaryButton } from '@banhala/ui-kit';
import { useOpenDeeplink } from '../../../../hooks';

export const FooterMore: React.FC<FooterMoreProps> = ({ footer, screen }) => {
  const { openDeeplink } = useOpenDeeplink();
  const { navigator } = useNavigator();

  if (isNil(footer)) return null;

  const handleClickViewAllButton = () => {
    const { deeplink } = footer.item;
    if (deeplink === null) {
      return;
    }

    logClickViewAllButton({ logging: footer.logging, screen });

    if (navigator.moveToGoodsList(deeplink)) return;

    openDeeplink(deeplink);
  };

  return (
    <Flex padding={{ horizontal: 16 }} margin={{ top: footer.item.margin_top }}>
      <PrimaryButton
        color="gray"
        size="large"
        variant={'fill'}
        outline
        onPress={handleClickViewAllButton}
      >
        {footer.item.title}
      </PrimaryButton>
    </Flex>
  );
};

const logClickViewAllButton = ({
  logging,
  screen,
}: {
  logging: IScreensLogging;
  screen?: string;
}) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_MORE',
    analytics: {
      ...(isNotNil(screen) && { SCREEN: screen }),
      ...logging.analytics,
    },
    ably_only_log: logging.ably_only_log,
  });
};
